/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import useScrollToTop from "./ScrollToTop";
let Item = (props) => {
    useScrollToTop();
    return(
        <>
        <div className="vision_con">
            {
                (props.list.length > 0 && props.list[0].banner)?
                <div className="vision_con">
                    <div className="vc_img vc_w"><img src={require("../../image/"+props.list[0].banner+"_w.png").default} alt="img_vision_w"></img></div>
                    <div className="vc_img vc_m"><img src={require("../../image/"+props.list[0].banner+"_m.png").default} alt="img_vision_m"></img></div>
                </div>:null
            }
        </div>
            
        {
            // sheet API回傳list數量大於1，代表畫面中有多個子分頁需切換
            (props.list.length > 1)?
            <div className="tab tab_commodity">
                <div className="pagesize">
                    <div className="tab_main">
                    {/* 難解問題： 不確定bolean 判斷式是否不支援多行(多標籤)，以下拆解成2個寫才成功 */}
                    {
                        props.list.map((item, index ) =>(                        
                            <div key={index} 
                                 className={(props.selectedPage === item.id)?"tab_a select " + item.name:"tab_a " + item.name} 
                                 onClick={()=>props.setPage(item.id)}
                            > 
                                <a></a>
                                {item.title}
                            </div>
                        ))
                    }             
                    </div>
                </div>
            </div>:null
        }
		</>		
    )
}
let PageMainTabView = (props) =>{
    return (
        <Item selectedPage={props.selectedPage} setPage={props.setPage} list={props.list}/>
    )
}

export default PageMainTabView;